import { collection, getDocs, deleteDoc, addDoc } from 'firebase/firestore';
import { db } from '../firebase/config';
import { DEFAULT_CATEGORIES } from './constants';

// Function to completely reset categories to the new structure
export const resetCategoriesToLatest = async (familyId, userId) => {
  try {
    console.log('🔄 Starting category cleanup and reset...');
    
    const categoriesRef = collection(db, `families/${familyId}/categories`);
    
    // Step 1: Get all existing categories
    console.log('📋 Checking existing categories...');
    const existingCategories = await getDocs(categoriesRef);
    console.log(`Found ${existingCategories.docs.length} existing categories`);
    
    // Step 2: Delete ALL existing categories (including duplicates)
    console.log('🗑️ Deleting ALL existing categories...');
    if (!existingCategories.empty) {
      const deletePromises = existingCategories.docs.map((doc, index) => {
        console.log(`Deleting ${index + 1}/${existingCategories.docs.length}: ${doc.data().name}`);
        return deleteDoc(doc.ref);
      });
      await Promise.all(deletePromises);
      console.log('✅ All old categories deleted');
    }
    
    // Step 3: Wait a moment for Firestore to process deletions
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    // Step 4: Add exactly 10 new categories
    console.log('➕ Adding exactly 10 new categories...');
    const addPromises = DEFAULT_CATEGORIES.map((category, index) => {
      console.log(`Adding ${index + 1}/10: ${category.icon} ${category.name} (${category.subcategories.length} subcategories)`);
      return addDoc(categoriesRef, {
        ...category,
        isDefault: true,
        createdAt: new Date(),
        createdBy: userId
      });
    });
    
    await Promise.all(addPromises);
    
    // Step 5: Verify the result
    console.log('🔍 Verifying new categories...');
    const newCategories = await getDocs(categoriesRef);
    console.log(`✅ Verification complete: ${newCategories.docs.length} categories now in database`);
    
    console.log('🎉 Categories reset complete! New structure:');
    DEFAULT_CATEGORIES.forEach((cat, index) => {
      console.log(`${index + 1}. ${cat.icon} ${cat.name} (${cat.subcategories.length} subcategories)`);
    });
    
    return { success: true, message: `Categories updated successfully. Now have ${DEFAULT_CATEGORIES.length} categories.` };
  } catch (error) {
    console.error('❌ Error resetting categories:', error);
    return { success: false, error: error.message };
  }
};

// Function to check current categories in Firestore
export const checkCurrentCategories = async (familyId) => {
  try {
    const categoriesRef = collection(db, `families/${familyId}/categories`);
    const snapshot = await getDocs(categoriesRef);
    
    console.log('📊 Current categories in Firestore:');
    snapshot.docs.forEach((doc, index) => {
      const data = doc.data();
      console.log(`${index + 1}. ${data.icon} ${data.name} (${data.subcategories?.length || 0} subcategories)`);
    });
    
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error('Error checking categories:', error);
    return [];
  }
};
